export const maskRUT = (rut: string): string => {
    let cleanRut = rut.replace(/[^0-9kK]/g, '').toUpperCase()

    let rutBody = cleanRut.slice(0, -1)
    let dv = cleanRut.slice(-1)

    rutBody = rutBody.slice(0, 8)
    dv = dv.replace(/[^0-9K]/g, '')

    let formatted = ''
    if (rutBody.length > 0) {
        let reversed = rutBody.split('').reverse()
        let withDots: string[] = []

        for (let i = 0; i < reversed.length; i++) {
            withDots.push(reversed[i])
            if ((i + 1) % 3 === 0 && i + 1 < reversed.length) {
                withDots.push('.')
            }
        }

        formatted = withDots.reverse().join('')
    }

    if (dv) {
        formatted += `-${dv}`
    }

    return formatted
}

export const unmaskRUT = (rut: string): string => {
    return rut.replace(/[.]/g, '')
}
